import CircleRadiusChart from './CircleRadiusChart';

export default function LearningProgress({ courseStatusCounts, apprenticeshipStatusCounts }) {
  const status = { ...courseStatusCounts }
  if (apprenticeshipStatusCounts !== 0) {
    Object.keys(apprenticeshipStatusCounts).forEach((key) => {
      status[key] = (status[key] || 0) + apprenticeshipStatusCounts[key];
    });
  }
  const data = 
   [
      {
        name: 'Completed',
        value: status.completed ?? 0,
      },
      {
        name: 'In progress', 
        value: status.inprogress ?? 0,
      },
      {
        name: 'Not Started',
        value: status.notstarted ?? 0,
      }
  ];
  
  return (
    <div className="learning-progress-content">
      <CircleRadiusChart 
        key={JSON.stringify(data)}
        data={data}
      />
    </div>
  );
}
